import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import TrendChip from '../../TrendChip';
import getArrowIcon from '../../utils/getArrowIcon';
import styles from './styles.module.scss';
import { TRENDING_STATUS } from '../../constants';

export default function TrendCell({
  value,
  variation,
  percentageStatus,
  invertColors = false,
  hideTrend = false,
  showValueOnNeutral = false,
}) {
  return (
    <Box className={styles.trendCell}>
      {percentageStatus === TRENDING_STATUS.NEUTRAL && !showValueOnNeutral ? (
        <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
      ) : (
        <Text variant="body.fontSize13">{value}</Text>
      )}

      <Box __css={{ visibility: hideTrend ? 'hidden' : 'visible' }}>
        <TrendChip
          text={variation}
          percentageStatus={percentageStatus}
          icon={getArrowIcon(percentageStatus)}
          invertColors={invertColors}
        />
      </Box>
    </Box>
  );
}
